export const OUTLINE_STOP_CONFIRMATION = '停止这批剧本拆分？后续未发送的请求将停止，已经发送给模型的请求仍可能计费。现有已保存结果不会删除；当前不支持分段断点续跑，重新启动可能重新处理已完成的分段。';

export const outlineTaskAttachment = (task = {}, requestId = '', source = '') => {
  const canonicalId = task.internalTaskId || task.taskId || requestId;
  const deduplicated = task.deduplicated === true || task.deduplicated === 'true'
    || Boolean(requestId && canonicalId && requestId !== canonicalId);
  return {
    requestId: canonicalId,
    canonicalSource: task.source || source,
    deduplicated,
    provider: task.provider || '',
    message: deduplicated
      ? `已接入正在执行的已有任务，未重复提交${task.provider ? `；原线路：${task.provider}` : ''}`
      : '任务已提交，等待后台执行',
  };
};

export const isOutlineSafetyStop = (value = {}) => {
  const status = String(value.taskStatus || value.transportStatus || value.status || '').toLowerCase();
  return ['canceled', 'cancelled', 'stopped'].includes(status)
    || /预算|消耗上限|费用上限|请求次数上限|停止后续请求|用户已停止|OUTLINE_BUDGET/i.test(String(value.message || value.errorMessage || ''));
};
